module.exports = __webpack_public_path__ + "img/royal-reef.353cacde.jpg";